export default {
  FETCH_DATA: 'wop_fetch_data',
  UPDATE_QUERY: 'wop_update_query',
  LOAD_MORE_DATA: 'wop_load_more_data',
  UPDATE_LOADING: 'wop_update_loading',
  UPDATE_SELECTED: 'wop_update_selected',
  UPDATE_ONE_DATA: 'wop_update_one_data',
  UPDATE_SELECTED_ROW_KEY: 'wop_update_selected_row-key',
};
